import Axios from 'axios';

export const makeCall = (url, method, data, headers, callback) => {
    let promise = Axios({
        method,
        url,
        data,
        headers,
    });

    if (callback) {
        promise = promise
            .then((res) => {
                callback(res.data);
                return res;
            })
            .catch((error) => {
                console.log(error);
            });

        return {};
    }

    return promise;
};

export const makeAuthenticatedCall = (
    url,
    method,
    data,
    authContext,
    callback
) => {
    const { auth, setAuth } = authContext;
    const { token } = auth;
    const headers = { Authorization: token };

    let promise = makeCall(url, method, data, headers);

    // add callback
    if (callback) {
        promise = promise.then((res) => callback(res.data));
    }

    promise = promise.catch((error) => {
        // only handle case when existing token becomes invalid.
        if (error?.response?.status === 401) {
            setAuth({
                ...auth,
                isExpired: true,
            });
        }
        if (callback) {
            // silence the error, since callback is only meant to be invoked
            // when the call is successful.
            console.error(error);
        } else {
            // throw the err in case there is no callback.
            // It should be handled by the caller of this function.
            throw error;
        }
    });

    if (!callback) {
        return promise;
    }
    return null;
};

export const formFormData = (file) => {
    const formData = new FormData();
    formData.set(`file`, file);
    return formData;
};
